import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { sidebarConfig, SidebarItem, isSidebarPathActive } from '../userConfiguration/sidebar';

export const useSidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => !prev);
  }, []);

  const toggleMobile = useCallback(() => {
    setMobileOpen(prev => !prev);
  }, []);

  const closeMobile = useCallback(() => {
    setMobileOpen(false);
  }, []);

  const isActive = useCallback((path: string) => {
    return isSidebarPathActive(path, location.pathname);
  }, [location.pathname]);

  const getActiveItem = useCallback(() => {
    return sidebarConfig.find(item => 
      isActive(item.path) || 
      (item.children && item.children.some(child => isActive(child.path)))
    );
  }, [isActive]);

  const getBreadcrumbs = useCallback(() => {
    const breadcrumbs: SidebarItem[] = [];
    
    const findBreadcrumbs = (items: SidebarItem[], targetPath: string): boolean => {
      for (const item of items) {
        if (isActive(item.path)) {
          breadcrumbs.push(item);
          return true;
        }
        if (item.children) {
          if (findBreadcrumbs(item.children, targetPath)) {
            breadcrumbs.unshift(item);
            return true;
          }
        }
      }
      return false;
    };

    findBreadcrumbs(sidebarConfig, location.pathname);
    return breadcrumbs;
  }, [location.pathname, isActive]);

  return {
    collapsed,
    mobileOpen,
    toggleCollapsed,
    toggleMobile,
    closeMobile,
    isActive,
    getActiveItem,
    getBreadcrumbs,
    currentPath: location.pathname,
  };
}; 